import styled from 'styled-components'

export const ComparisonContainerStyled = styled.section`
  display: flex;
  flex-direction: column;  
  gap:10px;
  margin-top: 10px;
  padding: 10px;
  width: 90%;
`
